export default floor => {
  const floors = {
    default: "default",
    men: "men",
    women: "women"
  };

  return floors[`${floor}`.toLowerCase()] || floors.default;
};
